import { render, staticRenderFns } from "./CalendarConfig.vue?vue&type=template&id=12d4ad3f"
import script from "./CalendarConfig.vue?vue&type=script&lang=js"
export * from "./CalendarConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports